import { create } from '@theme/create';
import { fontSizes } from '@theme/theme.fontSizes';

export const themed = create(
  new (function () {
    this.wrapper = {
      variant: 'flex.column.start.between',
      height: '100%',
      width: '100%',
      position: 'relative',
      '[data-comp="AddToCart"]': {
        opacity: 1,
        transition: 'all 0.2s ease-in-out',
        ':focus': {
          opacity: 1,
        },
      },
      ':hover': {
        '[data-comp="AddToCart"]': {
          opacity: 1,
        },
      },
    };

    this.quizWrapper = {
      display: 'grid',
      '[data-comp="Locale.Variant"] p': {
        fontSize: 18,
      },
    };

    this.content = {
      width: '100%',
      position: 'relative',
      zIndex: 0,
    };

    this.atc = {
      mt: [8, 10],
      width: ['100%', 'unset'],
    };
  })()
);
